export default __webpack_public_path__ + "db663162174e8d24e25a8ad1a23a6591.png";